/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

export class PriceUpdateListResponse {
  public createdDate: string;
  public file: string;
  public filePath: string;
  public title: string;
  public id: number;

  constructor(searchOptionListForm: any) {
    this.createdDate = searchOptionListForm.createdDate || '';
    this.file = searchOptionListForm.file || '';
    this.filePath = searchOptionListForm.filePath || '';
    this.title = searchOptionListForm.title || '';
    this.id = searchOptionListForm.id || '';

  }
}
